import {ReplaySubject, combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {isSubAccount$} from '@px/streams/user';
import {isUtaSpot$} from '@px/streams/uta-state';

export const isSupportMarginTrading$ = new ReplaySubject<boolean>(1);

combineLatest([isUtaSpot$, isSubAccount$])
  .pipe(map(([isUtaSpot, isSubAccount]) => isUtaSpot || !isSubAccount))
  .subscribe((isSupport) => isSupportMarginTrading$.next(isSupport));
